<template>
    <div class="ticket">
        <div class="row spacer" v-if="$root.app.platform == 'ios'">&nbsp;</div>
        
        <div class="row head">
            <div class="col col-80">{{ticket.subject}}</div>
            <div class="col col-20">
                <span class="status" v-bind:class="'status--'+ticket.statusId"></span>
            </div>
        </div>
<!--        <div class="row setting">
            <div class="col col-100">
                <span class="subtitle">Ticket #{{ ticket.id }}</span><br/>
                Geplaatst {{ ticket.creationTime }}<br/>
                laatst bijgewerkt: {{ ticket.updateTime }}<br/><br/>
                Status: {{ ticket.statusName }}<br/><br/>
                <b>{{ ticket.message }}</b><br/>
            </div>
        </div>-->

        <div class="row ticket-chat">
            <div class="col col-100">
                <div class="message">
                    <div v-html="ticket.message"></div>
                    <div class="time">{{ ticket.creationTime }}</div>
                </div>
            </div>
        </div>

        <div class="row ticket-chat" v-for="(item, index) in conversation">
            <div class="col col-100">
                <div class="message" v-bind:class="{employee: item.isEmployee}">
                    <div v-html="item.message"></div>
                    <div class="time">{{ item.creationTime }}</div>
                </div>
                <div class="clear"></div>
                <div v-if="item.statusChange">
                    <div class="status-change">De status is gewijzigd naar <b>{{item.statusChange}}</b></div>
                </div>
            </div>
        </div>
        <div class="new-message" v-if="ticket.locked != 1">
            
            <div v-if="$root.app.platform == 'android'" class="row row-last setting">
                <div class="col col-80">
                    <div class="form-group" v-bind:class="{ 'form-group--error': $v.newMessage.$error }">
                        <textarea class="form__input form__textarea form__textarea--small" type="text" placeholder="Typ hier je bericht" v-model="newMessage" @input="$v.newMessage.$touch()"></textarea>
                    </div>
                </div>
                <div class="col col-20 new-message__btn" @click="submit()">
                    <img src="/static/ticket-submit.svg" width="21" height="19">
                </div>
            </div>
            
            <div v-if="$root.app.platform == 'ios'" class="row row-last setting">
                <div class="col col-100">
                    <div class="form-group" v-bind:class="{ 'form-group--error': $v.newMessage.$error }">
                        <textarea class="form__input form__textarea form__textarea--small" type="text" placeholder="Typ hier je bericht" v-model="newMessage" @input="$v.newMessage.$touch()"></textarea>
                    </div>
                </div>
                <div class="col col-100">
                    <button class="button" @click="submit()">Bericht versturen</button>
                </div>
                <span class="form-group__message" v-if="!$v.newMessage.required">Veld is verplicht</span>
                <span class="form-group__message" v-if="!$v.newMessage.minLength">Bericht dient minimaal {{$v.form.message.$params.minLength.min}} tekens te bevatten.</span>
            </div>
            
<!--            <span class="form-group__message" v-if="!$v.newMessage.required">Field is required</span>
            <span class="form-group__message" v-if="!$v.newMessage.minLength">Message must have at least {{$v.newMessage.$params.minLength.min}} letters.</span>
            <div class="form-group" v-bind:class="{ 'form-group--error': $v.newMessage.$error }">
                <button class="button" @click="submit()">Bericht verzenden</button>
            </div>
            
            <label for="message">Nieuw bericht</label>
            <textarea v-model="newMessage" name="message" placeholder="Typ hier uw bericht.."></textarea>
            <button class="button" @click="submit">Bericht verzenden</button>-->
        </div>
    </div>
</template>

<script>
    
    import { required, minLength, numeric } from 'vuelidate/lib/validators'
    
    export default {
        data () {
            
            return {
                newMessage: [],
                ticket: [],
                conversation: [],
                refreshInterval: ''
            }
        },
        
        validations: {
            newMessage:{
                required,
                minLength: minLength(10)
            },
        },
        
        created(){
            
            var id = this.$route.params.id;
            
            this.getTicket(id);
            
            var _this = this;
            
            this.refreshInterval = setInterval(function(){
                
                _this.getTicket(id);
            }, 30000);
        },
        
        beforeDestroy(){
            
            clearInterval(this.refreshInterval);
        },
        
        methods:{
            
            create(){
                
                this.$router.push({path: '/feedback/create'});
            },
            
            
            getTicket(id){
                
                this.$api.get('/tickets?id='+id)
                .then(response => {

                    this.motd = response.data.motd;
                    this.ticket = response.data.ticket;
                    this.conversation = (response.data.ticket.conversation ? response.data.ticket.conversation : []);
                })
                .catch(e => {

                    //Throw back to list, invalid ticket

                    this.$router.push({path: '/feedback'});
                });
            },
            
            submit(){
                
                this.$api.post('/tickets/message', {
                    ticketID: this.ticket.id,
                    message: this.newMessage
                })
                .then(response => {
                    
                    //Empty textarea
                    this.newMessage = '';
                    
                    //Display new item
                    this.conversation.push(response.data.created);
                })
                .catch(e => {
                    
                    //Something went wrong.
                    
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/tickets/Ticket.vue